import { render, staticRenderFns } from "./AreaBoundaryEditor.vue?vue&type=template&id=6c6aaf24&scoped=true"
import script from "./AreaBoundaryEditor.vue?vue&type=script&lang=js"
export * from "./AreaBoundaryEditor.vue?vue&type=script&lang=js"
import style0 from "./AreaBoundaryEditor.vue?vue&type=style&index=0&id=6c6aaf24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6aaf24",
  null
  
)

export default component.exports